interface Props {
  pageNumber: number | string
  pageIndex: number
  onClick: (pageNumber: number) => void
}

const currentClassName = "z-10 bg-primary-50 border-primary-500 text-base-dark"
const defaultClassName =
  "border-gray-300 text-gray-500 hover:bg-gray-50 bg-white"

const NumberPagination = ({ pageNumber, pageIndex, onClick }: Props) => (
  <button
    // add conditional aria-label for accessibility if the current page is the same as the pageNumber
    aria-label={
      pageNumber === pageIndex + 1
        ? `Current Page, Page ${pageNumber}`
        : `Page ${pageNumber}`
    }
    {...(pageNumber === pageIndex + 1 && {
      "aria-current": "page"
    })}
    key={pageNumber}
    type="button"
    className={`${
      pageNumber === pageIndex + 1 ? currentClassName : defaultClassName
    } relative inline-flex items-center px-4 py-2 border text-sm font-medium hover:text-base-dark`}
    onClick={() => onClick(Number(pageNumber) - 1)}
  >
    {pageNumber}
  </button>
)

export default NumberPagination
